export const countrySettings = {
  FI: {
    currency: 'EUR',
    currencySymbol: '€',
    taxPercentages: { General: 24, Reduced1: 14, Reduced2: 10 },
    productTaxes: { reservation: 'Reduced2', serviceEntry: 'General' },
  },
  SE: {
    currency: 'SEK',
    currencySymbol: 'SEK',
    taxPercentages: { General: 25, Reduced1: 12, Reduced2: 6 },
    productTaxes: { reservation: 'Reduced1', serviceEntry: 'General' },
  },
};
